<template>
  <div class="row">
    <div
      class="text-center p-left-half p-right-half full-width d-inline-block m-bottom m-top"
      @click="onClick()"
    >
      <a
        class="btn btn-secondary col-xs-12 col-sm-4 col-sm-offset-4 col-md-4 col-md-offset-4"
        >{{ text }}</a
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ButtonComponent",
  props: {
    text: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  methods: {
    onClick() {
      this.$emit("onClick");
    },
  },
};
</script>

<style scoped>
.row {
  margin-right: 0px;
  margin-left: 0px;
}
.text-center {
  text-align: center !important;
}
.p-left-half {
  padding-left: 10px !important;
}
.p-right-half {
  padding-right: 10px !important;
}
.m-bottom {
  margin-bottom: 20px !important;
}
.m-top {
  margin-top: 20px !important;
}
.full-width {
  width: 100% !important;
}
.d-inline-block {
  display: inline-block;
}
.text-center {
  text-align: center;
}
.btn-secondary {
  background: #273e5b;
  background: -moz-linear-gradient(
    top,
    rgba(39, 62, 91, 0.7) 0%,
    rgba(39, 62, 91, 0.9) 100%
  );
  background: -webkit-linear-gradient(
    top,
    rgba(39, 62, 91, 0.7) 0%,
    rgba(39, 62, 91, 0.9) 100%
  );
  background: linear-gradient(
    to bottom,
    rgba(39, 62, 91, 0.7) 0%,
    rgba(39, 62, 91, 0.9) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='rgba($gradient,.7)', endColorstr='rgba($gradient,.9)',GradientType=0 );
  color: #ffffff;
  fill: #ffffff;
  text-transform: uppercase;
  border: none;
  border-bottom: 4px solid #182637;
}
.btn {
  position: relative;
  height: 50px;
  padding: 14px 20px;
  background-color: transparent;
  border-radius: 4px;
  font-size: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  text-decoration: none;
  outline: 0;
  min-width: fit-content;
}
.btn {
  display: inline-block;
  padding: 14px 3px;
  margin-bottom: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  border-radius: 10px;
}
@media (min-width: 768px) {
  .col-sm-offset-4 {
    margin-left: 33.33333333%;
  }
  .col-sm-4 {
    width: 33.33333333%;
  }
  .col-sm-1,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12 {
    float: left;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/ButtonComponent.vue